import type { CaseStudy } from './types';

const items = import.meta.glob<CaseStudy>('./case-studies/*.json', { eager: true, import: 'default' });
const bodies = import.meta.glob<string>('./case-studies/*.html', { query: '?raw', import: 'default' });

export const caseStudies: CaseStudy[] = Object.values(items).sort((a, b) => a.slug.localeCompare(b.slug));

export const getCaseStudy = (slug: string) => caseStudies.find((c) => c.slug === slug);

export async function loadCaseStudyBody(slug: string): Promise<string> {
  return (await bodies[`./case-studies/${slug}.html`]?.()) ?? '';
}
